import * as React from 'react'

import { classList } from 'react-classlist-helper'

import { Button } from '~/client/src/shared/components/Button/Button'
import { AddIcon } from '~/client/src/shared/components/icons/AddIcon'
import { ChevronDownIcon } from '~/client/src/shared/components/icons/ChevronDownIcon'

import SectionLabel from './SectionLabel'

interface IProps {
  count: number
  isExpanded: boolean
  onToggle: () => void
  onCreateNew: () => void
  countLabel: (count: number) => string
  sectionLabel: string
  addButtonLabel: string
}

export default function CollapsibleSectionHeader({
  count,
  isExpanded,
  onToggle,
  onCreateNew,
  countLabel,
  sectionLabel,
  addButtonLabel,
}: IProps): JSX.Element {
  const addButton = (
    <Button
      variant="ghost"
      onClick={onCreateNew}
      className="tw:w-fit tw:text-muted-foreground"
      size="lg"
    >
      <AddIcon data-icon="inline-start" size="xs" />
      {addButtonLabel}
    </Button>
  )

  if (count > 0) {
    return (
      <div className="tw:flex tw:flex-col tw:py-3">
        <button
          type="button"
          className="tw:flex tw:items-center tw:gap-1 tw:cursor-pointer tw:bg-transparent tw:border-none tw:p-0"
          onClick={onToggle}
        >
          <ChevronDownIcon
            size="xs"
            className={classList({
              'tw:transition-transform': true,
              'tw:text-muted-foreground': isExpanded,
              'tw:text-foreground tw:-rotate-90': !isExpanded,
            })}
          />
          <span
            className={classList({
              'tw:text-sm tw:font-medium tw:leading-5': true,
              'tw:text-muted-foreground': isExpanded,
              'tw:text-foreground': !isExpanded,
            })}
          >
            {countLabel(count)}
            {isExpanded && ':'}
          </span>
        </button>
        {!isExpanded && <div className="tw:pt-1">{addButton}</div>}
      </div>
    )
  }

  return (
    <div className="tw:flex tw:flex-col tw:py-3">
      <SectionLabel text={sectionLabel} />
      {addButton}
    </div>
  )
}
